export default __webpack_public_path__ + "static/media/edit-icon-black.9d393eb8.svg";